import styled from "styled-components";

const StyledSharedLayout = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

export default StyledSharedLayout;
